/** ***********
*
* <type-of.pipe.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/

import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'typeOf',
    standalone: false
})
export class TypeofPipe implements PipeTransform {

    // Get an unknown type value, check and return the type of the received value
    transform(value: unknown): string {
        // reg exp which match with ISO 8601 date format (ex : YYYY-MM-DDTHH:MM:SS+0000 or 'YYYY-MM-DDTHH:MM:SS' or YYYY-MM-DDTHH:MM or YYYY-MM-DD )
        const dateRegExp = new RegExp(/^\d{4}-(0[1-9]|1[0-2])-([12]\d|0[1-9]|3[01])([T\s](([01]\d|2[0-3]):[0-5]\d|24:00)(:[0-5]\d([.,]\d+)?)?([zZ]|([+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?$/);
        if (Array.isArray(value)) {
            return 'array';
        } else if ((typeof value === 'string' && dateRegExp.test(value)) || (value instanceof Date)) {
            return 'date';
        } else if (typeof value === 'object' && (value as any)?.value ) {
            return 'object';
        } else {
            return typeof value;
        }
    }
}
